import { Directive, EventEmitter, Output } from "@angular/core";

@Directive()
export class WidgetExtraTitleDirective {
    @Output()
    private extraTitle = new EventEmitter<string>();

    constructor() {}

    emitExtraTitle(title: string): void {
        this.extraTitle.emit(title);
    }
}
